import { Button, VStack } from '@chakra-ui/react';
import { currentWallet } from '@cronos-app/wallet';
import { DialogOrDrawer } from '@ui/components/DialogOrDrawer';

import { SelectChain } from '../components/SelectChain';
import { useAccountDialog } from '../useAccountDialog';
import { Address } from './Address';
import { Nickname } from './Nickname';
import { SocialLinks } from './SocialLinks';
import { TokenList } from './TokenList';

export const DefaultContent = () => {
  return (
    <>
      <DialogOrDrawer.Body pt="24px">
        <VStack alignItems="center">
          <Nickname />
          <Address />
        </VStack>
        <TokenList mt="24px" />
      </DialogOrDrawer.Body>
      <DialogOrDrawer.Footer alignItems="stretch" pt="16px">
        <SocialLinks />
        <SelectChain />
        <Button
          variant="tertiary"
          color="state.error"
          onClick={async () => {
            await currentWallet.disconnect();
            useAccountDialog.getState().close();
          }}
        >
          Disconnect
        </Button>
      </DialogOrDrawer.Footer>
    </>
  );
};
